import { interactions } from '../rules/interactions';

export const reactMenu = {
  '.eds__react-menu': {
    borderRadius: 'm',
    boxShadow: 'dropdown',
    maxHeight: 'menu.max-height',
    maxWidth: 'dropdown.max-width',
    minWidth: 'dropdown.min-width',
    overflowY: 'auto',
    paddingBottom: 2,
    paddingTop: 2,
  },
  '.eds__react-menu--embedded': {
    borderRadius: 'unset',
    boxShadow: 'unset',
    minWidth: 'unset',
    padding: 'unset',
    position: 'unset',
    width: '100%',
  },
  '.eds__react-menu__group:not(:last-child)': {
    borderBottom: 'border.divider',
  },
  '.eds__react-menu__header': {
    padding: 'unset',
    paddingBottom: 1,
    paddingTop: 3,
  },
  '.eds__react-menu__menu-button': {
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 'unset',
    borderRadius: 'm',
    cursor: 'pointer',
    display: 'flex',
    padding: 0,
    outlineColor: 'transparent',
  },
  '.eds__react-menu__menu-button:not(:has(.light-theme-nav-pill)):hover': {
    border: 'unset', // can be removed once ./react-menu_override.css is deprecated
    ...interactions[':hover'],
  },
  '.eds__react-menu__menu-button:not(:has(.light-theme-nav-pill)):focus':
    interactions[':focus'],
  '.eds__react-menu__menu-button:not(:has(.light-theme-nav-pill)):active':
    interactions[':active'],
  '.eds__react-menu__menu-button:not(:has(.light-theme-nav-pill)):hover:focus':
    interactions[':hover:focus'],
  '.eds__react-menu__menu-button:not(:has(.light-theme-nav-pill)):hover:focus:active':
    interactions[':hover:focus:active'],
  '.eds__react-menu__menu-button--embedded': {
    visibility: 'hidden',
  },
  '.eds__react-menu__menu-item': {
    display: 'block',
    padding: 0,
  },
};
